module.exports = __webpack_public_path__ + "static/media/chevron-double-down.a2445f5d.svg";